var filterByPathAndArea = function filterByPathAndArea(path) {
  return function (perm) {
    if (perm.Path && perm.Area) {
      var regexPath = new RegExp(perm.Path);
      return regexPath.test(path);
    } else {
      return false;
    }
  };
};

export default filterByPathAndArea;